import React from 'react';
import Window from '../os/Window';
import Wordle from '../wordle/Wordle';

export interface BordleAppProps extends WindowAppProps {}

const BordleApp: React.FC<BordleAppProps> = (props) => {
    return (
        <Window
            top={20}
            left={300}
            width={600}
            height={860}
            windowBarIcon="windowGameIcon"
            windowTitle="Bordle"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
            bottomLeftText={'© Copyright 2025 Emirhan Bölek'}
        >
            <div className="site-page">
                <Wordle />
            </div>
        </Window>
    );
};

export default BordleApp;
